import { useState, useEffect } from "react"
import { useAuth0 } from "@auth0/auth0-react"

export const useUserResumes = () => {
  const [resumes, setResumes] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const { getAccessTokenSilently } = useAuth0()
  const apiUrl = process.env.REACT_APP_API_URL

  useEffect(() => {
    const fetchResumes = async () => {
      try {
        const token = await getAccessTokenSilently({
          authorizationParams: {
            audience: process.env.REACT_APP_API_AUDIENCE,
          },
        })
        const response = await fetch(`${apiUrl}/api/resumes/user`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        if (response.ok) {
          const data = await response.json()
          setResumes(data)
        } else {
          setError(`Failed to fetch resumes: ${response.statusText}`)
        }
      } catch (err) {
        setError(`Error fetching resumes: ${err.message}`)
      } finally {
        setLoading(false)
      }
    }

    fetchResumes()
  }, [getAccessTokenSilently, apiUrl])

  return { resumes, loading, error }
}

